import {
  ProcessExecutionType,
  ProcessPlatformFeatureType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getProcessPlatformFeatureConfig} from 'processes/processes-platform/FeatureOptions';

interface MaybeConfigableSchema {
  id: string;
  name: string;
  executionType: ProcessExecutionType;
}

interface MaybeCreatableSchema {
  id: string;
  name: string;
  executionType: ProcessExecutionType;
}

export function canConfigureProcessTaskSchema(schema: MaybeConfigableSchema): boolean {
  return getProcessPlatformFeatureConfig(
    ProcessPlatformFeatureType.SCHEMA_CONFIG,
    schema.executionType,
    schema.name
  );
}

export function userCreatableProcessTaskSchema(schema: MaybeCreatableSchema): boolean {
  return getProcessPlatformFeatureConfig(
    ProcessPlatformFeatureType.CAN_CREATE_TASK_GROUPS,
    schema.executionType,
    schema.name
  );
}
